import React, {useState, useEffect, useCallback} from "react";
import {useParams} from "react-router-dom";
import {Upload} from "antd";
import {InboxOutlined} from "@ant-design/icons";
import useS3Connection from "../hooks/useS3Connection";
import {fetchLatestPhoto, uploadPhoto} from "../operations/s3Operations";

const {Dragger} = Upload;


const BUCKET_NAME = "fr.cornil.photos40ans"
const ACCESS_KEY_ID = "AKIAUKG5CT65SPHII2PY"
const S3_REGION = "eu-west-3"

export default function PhotoUploader() {
    const {folderId} = useParams();
    const [latestPhotoUrl, setLatestPhotoUrl] = useState(null);
    const [error, setError] = useState(null);

    const s3 = useS3Connection({
        accessKeyId: ACCESS_KEY_ID,
        region: S3_REGION,
    });

    useEffect(() => {
        const fetchLatestPhotoAsync = async () => {
            const signedUrl = await fetchLatestPhoto({
                s3,
                folderId,
                bucketName: BUCKET_NAME,
            })
            setLatestPhotoUrl(signedUrl);
        };
        fetchLatestPhotoAsync();
    }, [s3, folderId, setLatestPhotoUrl]);

    const handleUpload = useCallback(async ({file, onSuccess, onError}) => {
        const photoUrl = await uploadPhoto({
            s3,
            folderId,
            bucketName: BUCKET_NAME,
            file,
            onSuccess,
            onError,
        });
        if (photoUrl) {
            setLatestPhotoUrl(photoUrl)
        } else {
            setError("Failed to upload photo")
        }
    }, [s3, folderId]);

    return (
        <div className="flex flex-col items-center p-4 gap-4">
            <div className="text-center text-lg font-medium">
                Prends une photo bien cadrée, en mode paysage
            </div>

            <Dragger
                customRequest={handleUpload}
                multiple
                showUploadList={false}
                accept="image/*"
                className="w-full max-w-md h-48 border-dashed border-2 rounded-xl bg-gray-50 flex items-center justify-center"
            >
                <p className="ant-upload-drag-icon">
                    <InboxOutlined style={{fontSize: 40}}/>
                </p>
                <p className="ant-upload-text">Appuie ici pour envoyer ta photo</p>
            </Dragger>
            {
                error && (
                    <div className={"mt-4"}>{error}</div>
                )
            }
            {latestPhotoUrl && (
                <div className="mt-4">
                    <div className="text-sm text-gray-500">Dernière photo envoyée :</div>
                    <div className={"flex flex-col items-center rounded border mt-1 max-h-80 aspect-video container"} >
                        <img
                            src={latestPhotoUrl}
                            alt="Dernier envoi"
                            className="object-contain max-h-full"
                        />
                    </div>
                </div>
            )}
        </div>
    );
}